import {createContext} from 'react';

const FormStepContext = createContext(null);

export default FormStepContext;
